fccd-icon-detail {
  .flex-container {
    display: flex;
  }

  .use-block {
    display: block;
  }

  .icon-padding {
    padding-right: var(--spacing-sm);
  }
}
